import { ExamReportService } from './../../../data/services/exam-report'
import { ExamReport } from './../../../data/models/exam-report'
import { IOperationServiceConfig } from './../../../model-repository'
import { JsonApiProcessor } from '../../../data/services'

export const ExamReportConfig: IOperationServiceConfig<ExamReport> = {
  service: ExamReportService,
  deps: [JsonApiProcessor],
  endpoint: 'exams/reports',
  model: ExamReport,
  mappings: [
    {
      classType: 'ExamReport',
      jsonType: 'reports',
      propertyMapping: {}
    }
  ]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/operation/exam-report.config.ts